// extracted by mini-css-extract-plugin
module.exports = {"divider":"divider_divider__2pc7p"};